import React, { useMemo } from 'react';
import { FormErrors, InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import classNames from 'classnames';
import styles from '../assets/reset-password-form.module.scss';
import { useTranslation } from 'react-i18next';
import { required, Validators } from 'src/components/redux-form/utils/validators';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import i18next from 'i18next';
import { asyncAuthUpdatePassword } from 'src/store/actions/auth-actions';
import { Link } from 'react-router-dom';
import Router from '../../../../../navigation/router';
import { routes } from '../../../../../navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';

export interface ResetPasswordFormData {
    password: string;
    passwordRepeat: string;
}

interface ResetPasswordFormProps {}

type InjectedProps = InjectedFormProps<ResetPasswordFormData, ResetPasswordFormProps>;

const ResetPasswordForm: React.FunctionComponent<InjectedProps & ResetPasswordFormProps> = ({
    handleSubmit,
    submitting,
    error,
}: InjectedProps & ResetPasswordFormProps) => {
    const { t } = useTranslation();
    const validators: Validators<ResetPasswordFormData> = useMemo(
        () => ({
            password: [required({ message: 'Password is required!' })],
            passwordRepeat: [required({ message: 'Confirm Password is required!' })],
        }),
        [],
    );

    return (
        <div className={classNames('')}>
            <div className={classNames('col-lg-3')}></div>
            <div className={classNames(styles.authContent)}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: '30px',
                        marginBottom: '10px',
                    }}
                >
                    <div className={classNames(styles.infoIcon, '  d-flex justify-content-center align-items-center')}>
                        <FontAwesomeIcon className={classNames(styles.icon)} icon={faQuestion} />
                    </div>
                    <div className={classNames(styles.infoIconTitle)}>Enter your new password:</div>
                </div>
                <form onSubmit={handleSubmit} className={classNames(styles.form)}>
                    <div>
                        <FormError error={error} />
                        <FieldInput
                            name="password"
                            type="password"
                            validate={validators.password}
                            wrapperConfig={{
                                label: 'New password:',
                            }}
                        />
                        <FieldInput
                            name="passwordRepeat"
                            type="password"
                            validate={validators.passwordRepeat}
                            wrapperConfig={{
                                label: 'New password Confirmation',
                            }}
                        />
                    </div>
                    <div className={classNames('text-center')}>
                        <button type="submit" className={classNames('btn', 'btn-success', 'text-uppercase', 'w-100')}>
                            {submitting ? <span className={classNames('spinner-border')} /> : t('Confirm')}
                        </button>
                    </div>
                    <div className={classNames(styles.links, 'text-center', 'mb-2')}>
                        <Link to={Router.generate(routes.HOME)}>Back to Login</Link>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default reduxForm<ResetPasswordFormData, ResetPasswordFormProps>({
    form: 'reset-password',
    validate: (values: ResetPasswordFormData): FormErrors<ResetPasswordFormData> => {
        const errors: FormErrors<ResetPasswordFormData> = {};

        if (values.passwordRepeat && values.password !== values.passwordRepeat) {
            errors.passwordRepeat = i18next.t('Password must match');
        }

        return errors;
    },
    onSubmit: asyncAuthUpdatePassword,
})(ResetPasswordForm);
